import type React from "react"
import { useEffect, useRef } from "react"
import { Card } from "react-bootstrap"
import * as echarts from "echarts";

// @ts-ignore
const BarChart: React.FC = ({ BarChartData }) => {
    const chartRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (!chartRef.current) return

        const chart = echarts.init(chartRef.current)

        const option = {
            title: {
                text: BarChartData?.title,
                textStyle: {
                    fontSize: 20,
                    fontWeight: 400,
                    color: "#18181B",
                    lineHeight: 16
                },
                left: 0,
                top: 0,
                subtext: BarChartData?.subtitle,
                subtextStyle: {
                    fontSize: 14,
                    color: "#838FB4",
                    fontWeight: 400,
                    lineHeight: 16,
                    width: 700,
                    overflow: "break"
                }
            },
            tooltip: {
                trigger: "axis",
            },
            grid: {
                top: "25%",
            },
            xAxis: {
                type: "category",
                data: BarChartData?.xAxis?.categories,
                name: BarChartData?.xAxis?.name,
                nameLocation: "middle",
                nameGap: 30,
                nameTextStyle: {
                    color: "#18181B",
                    fontSize: 16,
                    fontWeight: 400
                },
                axisLabel: {
                    rotate: 45,
                    fontSize: 12,
                    color: "#4B4B53",
                    fontWeight: 400,
                    formatter: function (value: string) {
                        const maxLength = 10;
                        return value.length > maxLength ? value.substring(0, maxLength) + '...' : value;
                    }
                },
            },
            yAxis: {
                type: "value",
                name: BarChartData?.yAxis?.name,
                nameLocation: "middle",
                // nameGap: 45,
                nameRotate: 90,
                nameTextStyle: {
                    color: "#18181B",
                    fontSize: 16,
                    fontWeight: 400
                },
                axisLabel: {
                    fontSize: 12,
                    color: "#4B4B53",
                    fontWeight: 400
                },
                splitLine: {
                    lineStyle: {
                        type: "dashed",
                        color: "rgba(0, 102, 204, 0.25)"
                    }
                },
            },
            series: BarChartData?.series?.map((s:any, index:number) => ({
                name: s?.name,
                type: "bar",
                data: s?.data,
                barMaxWidth: 50,
                itemStyle: {
                    color: index === 0 ? "#0066CC" : "#7784F5"
                }
            })) || [],
            // series: [
            //     {
            //         name: BarChartData?.series[0]?.name,
            //         type: "bar",
            //         data: BarChartData?.series[0]?.data,
            //         itemStyle: {
            //             color: "#0066CC"
            //         }
            //     },
            // ],
        }

        chart.setOption(option)

        const handleResize = () => {
            chart.resize()
        }

        window.addEventListener("resize", handleResize)

        return () => {
            window.removeEventListener("resize", handleResize)
            chart.dispose()
        }
    }, [BarChartData])

    return (
        <Card className="h-100 shadow-sm">
            <Card.Body className="p-3">
                <div ref={chartRef} style={{ width: "100%", height: "400px" }} />
            </Card.Body>
        </Card>
    )
}

export default BarChart;
